import loadable from '@loadable/component';

const PagerContainer = loadable(
  () => import(/* webpackChunkName: "PagerContainer.loadable" */ 'app/shared/modules/pager/PagerContainer/component'),
);

interface Props {
  maxPage: number;
  nextPage: number;
  currPage: number;
  prevPage: number;
  query: object;
  itemsPerPage: number;
  screenWidth: number;
  paginationUpperBound: number;
  resourceId: string;
  searchSlug: string;
}

const LoadablePagerContainer = (props: Props) => {
  return <PagerContainer {...props} />;
};

export default LoadablePagerContainer;
